import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const PressReleaseForm = ({ formData, onFormChange, onGenerate, isGenerating }) => {
  const genreOptions = [
    { value: 'fiction', label: 'Fiction' },
    { value: 'non-fiction', label: 'Non-Fiction' },
    { value: 'mystery', label: 'Mystery & Thriller' },
    { value: 'romance', label: 'Romance' },
    { value: 'sci-fi', label: 'Science Fiction' },
    { value: 'fantasy', label: 'Fantasy' },
    { value: 'biography', label: 'Biography' },
    { value: 'self-help', label: 'Self-Help' },
    { value: 'business', label: 'Business' },
    { value: 'children', label: 'Children\'s Books' }
  ];

  const targetAudienceOptions = [
    { value: 'general', label: 'General Public' },
    { value: 'industry', label: 'Publishing Industry' },
    { value: 'media', label: 'Media & Press' },
    { value: 'readers', label: 'Book Readers' },
    { value: 'professionals', label: 'Industry Professionals' },
    { value: 'academics', label: 'Academic Community' }
  ];

  const handleInputChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Book Title"
          type="text"
          placeholder="Enter the book title"
          value={formData?.bookTitle || ''}
          onChange={(e) => handleInputChange('bookTitle', e?.target?.value)}
          required
        />
        <Input
          label="Author Name"
          type="text"
          placeholder="Enter author's full name"
          value={formData?.authorName || ''}
          onChange={(e) => handleInputChange('authorName', e?.target?.value)}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Launch Date"
          type="date"
          value={formData?.launchDate || ''}
          onChange={(e) => handleInputChange('launchDate', e?.target?.value)}
          required
        />
        <Select
          label="Genre"
          options={genreOptions}
          value={formData?.genre || ''}
          onChange={(value) => handleInputChange('genre', value)}
          placeholder="Select book genre"
          required
        />
      </div>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Book Synopsis
          </label>
          <textarea
            className="w-full h-32 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            placeholder="Provide a brief synopsis of the book (2-3 sentences)"
            value={formData?.synopsis || ''}
            onChange={(e) => handleInputChange('synopsis', e?.target?.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Key Messages
          </label>
          <textarea
            className="w-full h-24 px-3 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            placeholder="Key points you want to highlight in the press release"
            value={formData?.keyMessages || ''}
            onChange={(e) => handleInputChange('keyMessages', e?.target?.value)}
          />
        </div>
      </div>
      <Select
        label="Target Audience"
        options={targetAudienceOptions}
        value={formData?.targetAudience || ''}
        onChange={(value) => handleInputChange('targetAudience', value)}
        placeholder="Select target audience"
        required
      />
      <Input
        label="Publisher/Company"
        type="text"
        placeholder="PenGame Publishing"
        value={formData?.publisher || 'PenGame Publishing'}
        onChange={(e) => handleInputChange('publisher', e?.target?.value)}
      />
      <Button
        onClick={onGenerate}
        loading={isGenerating}
        iconName="Sparkles"
        iconPosition="left"
        className="w-full"
        disabled={!formData?.bookTitle || !formData?.authorName || !formData?.launchDate}
      >
        {isGenerating ? 'Generating Press Release...' : 'Generate Press Release'}
      </Button>
    </div>
  );
};

export default PressReleaseForm;